import { ValidatorFn } from "@angular/forms";
import {
  FailureDescription,
  OneArgValidatorDef,
  VALIDATION_ERROR_MESSAGES,
  ValidationErrorMessages,
  ValidatorDef,
  VALIDATORS
} from "../model/form.model";
import { Attachment } from "src/app/model/file.model";
import { HttpEvent } from "@angular/common/http";
import { FormHeader, HeaderModel } from '../../settings/model/form.model';
import { Task } from '../model/task.model';

export function getErrorMessage(error: ValidationErrorMessages) {
  return VALIDATION_ERROR_MESSAGES[error] || 'ERRORS.VALIDATION';
}
export function isOneArgValidatorDef(def: ValidatorDef): def is OneArgValidatorDef {
  return 'argument' in def && !!def.argument;
}
export function getValidatorFn(def: ValidatorDef): ValidatorFn {
  if (isOneArgValidatorDef(def)) {
    const validatorFn = VALIDATORS[def.type];
    return validatorFn(def.argument);
  }
  return VALIDATORS[def.type];
}

export function countRegisteredDefects(obj: any) {
  let count = 0;

  if (typeof obj === 'object' && obj !== null) {
    for (let key in obj) {
      if (key === 'failureDescription') {
        if (Array.isArray(obj[key])) {
          count += obj[key].length;
        } else if (obj[key] !== null) {
          count += 1;
        }
      } else {
        count += countRegisteredDefects(obj[key]);
      }
    }
  }
  return count;
}

export function getRegisteredDefects(obj: any): FailureDescription[] {
  let defects: any[] = [];

  if (typeof obj === 'object' && obj !== null) {
    for (let key in obj) {
      if (key === 'failureDescription') {
        if (Array.isArray(obj[key])) {
          defects = defects.concat(obj[key]);
        } else if (obj[key] !== null) {
          defects.push(obj[key]);
        }
      } else {
        defects = defects.concat(getRegisteredDefects(obj[key]));
      }
    }
  }

  return defects;
}

export function getLastDefectNumber(defects: FailureDescription[]): number {
  return defects.map(item => Number(item.name.slice(-3))).sort((a, b) => a - b).at(-1) || 0;
}

export function isAttachmentArray(value:  Attachment[] | HttpEvent<Attachment[]>): value is Attachment[] {
  return value instanceof Array;
}

export function isAttachmentUploadEvent(value: Attachment[] | HttpEvent<Attachment[]>): value is HttpEvent<Attachment[]> {
  return !(value instanceof Array);
}

export const prepareFormHeaders = (headers: string[]): HeaderModel[] => {
  return headers.map(item => {
    return {
      headerKey: item,
      sticky: false,
      showInFailure: false
    }
  })
}

export const getFailureHeaders = (task: Task): FormHeader[] => {
  return task.form?.formHeaders.filter(x => x.showInFailure) || [];
}